import React from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { Card, CardBody, CardTitle, Col, CardHeader, FormGroup, Button, Spinner } from "reactstrap";

const InsightsSubmitDateRange = ({
                                     valueDateRange,
                                     setValueDateRange,
                                     handleSubmit,
                                     isSubmitting = false,
                                 }) => {
    return (
        <Col lg="4" md="6" sm="12">
            <Card>
                <CardHeader>
                    <CardTitle tag="h4">Insights Date Range</CardTitle>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <DateRangePicker
                            disabled={isSubmitting}
                            rangeDivider=" : "
                            className="form-logs-input-date"
                            value={valueDateRange}
                            onChange={(range) => {
                                if (range && range[0] instanceof Date && range[1] instanceof Date) {
                                    setValueDateRange(range);
                                }
                            }}
                            format="y-MM-dd"
                        />
                    </FormGroup>
                    <div className="submit-button-row">
                        <Button
                            className="btn-fill"
                            color="primary"
                            type="button"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <Spinner size="sm" className="me-2" />
                                </>
                            ) : (
                                "Submit"
                            )}
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default InsightsSubmitDateRange;
